import React, { memo, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useTheme, useMediaQuery } from "@mui/material";
import SummaryTable from "../../../common/components/summaryTable/summary";
import { keyStaticAnalysis } from "../nlg/nlg";
import Description from "../description";
import { Tooltip } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Info } from "@mui/icons-material";
import { dateMiladiToShamsi } from "../../../common/method/date";

const useStyles = makeStyles((theme) => ({
  tooltip: {
    maxWidth: 250,
    fontSize: 12,
    padding: 5,
  },
}));

const SummaryBoxReports = memo(({ tip }) => {
  const classes = useStyles();
  const [relatedDate, setRelatedDate] = useState("");
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const reducerselectKey = useSelector(
    (state) => state.select_portfolio_key_reducer,
  );

  useEffect(() => {
    if (reducerselectKey?.data?.length !== 0) {
      let date = dateMiladiToShamsi(
        reducerselectKey?.data[0]?._source.related_date,
      );
      setRelatedDate(date);
    }
  }, [reducerselectKey?.data]);

  const analysis = keyStaticAnalysis(reducerselectKey.data);

  return (
    <>
      <div
        className="flex justify-between items-center"
        style={{ width: "max-content" }}
      >
        <h1 className="pr-3  mt-2 mx-2">آمارها</h1>
        <Tooltip
          className="mt-1"
          title={
            <p className="p-2 m-0">
              {tip}

              {/* <video width="300" height="200" controls autoPlay>
                <source src="/media/video/Systematic Vs Unsystematic Risk 2.mp4" type="video/mp4" />
              </video> */}
            </p>
          }
          placement={isMobile ? "bottom" : "left"}
          arrow
          classes={{ tooltip: classes.tooltip }}
          enterTouchDelay={1}
        >
          <img src="/media/image/Group 12485.png" />
        </Tooltip>
      </div>
      {relatedDate && (
        <div className="text-gray-600 text-sm mr-5">({relatedDate})</div>
      )}

      <div className="grid grid-cols-12">
        <div className="col-span-12 lg:col-span-4">
          <div className="text-sm text-gray-700 p-5">
            اطلاعات کلی و آمارهای کلیدی مربوط به سرمایه‌گذاری شما شامل معیارهای
            بازدهی و ریسک، میزان شباهت به بازار و موارد مشابه دیگر توسط تحلیل‌گر
            خودکار کارگزاری پیشرو محاسبه شده و در این قسمت نمایش داده شده است.
          </div>
          <Description analysis={analysis} />
        </div>
        <div className="col-span-12 lg:col-span-8">
          <SummaryTable reducerselectKey={reducerselectKey} reports />
        </div>
      </div>
    </>
  );
});

export default SummaryBoxReports;
